fragment ReportViewFields on ReportView {
    title
    subtitle
    reportType
    displayTime
    htmlUrlPath
    savedFilter {
        id
    }
}
